import styled from "styled-components";
import { colors, devices, fonts } from "../../../utils/styled/_variables.styled";

export const InfiosKeyFactsItem = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
	min-height: 287px;
	padding: 40px;
	margin-top: 32px;
	flex-basis: 45%;
	flex-grow: 1;
	background-color: ${colors.white};

	@media ${devices.mobile} {
		width: calc(100vw - 48px);
	}

	span[aria-hidden="true"] {
		font-size: 0;
	}

	span[aria-hidden="true"]::after {
		content: "";
	}

	.handshake__icon {
		width: 46px;
		height: 40px;
		margin-bottom: 44px;

		@media ${devices.tabletLarge} {
			width: 38px;
			height: 33px;
			margin-bottom: 40px;
		}

		@media ${devices.mobile} {
			margin-bottom: 35px;
		}
	}

	.heading-1 {
		color: ${colors.blue};
		font-family: ${fonts.AeonikMono};
		text-transform: uppercase;
		margin-bottom: 16px;
		font-weight: 400;
		font-size: 80px;		

		span {
			color: inherit;
			overflow-wrap: break-word;
			transition: transform 400ms ease, opacity 400ms ease;
			transition-delay: 300ms;			
		}
		.span-1 {transition-delay: 400ms};
		.span-2 {transition-delay: 500ms};
		.span-3 {transition-delay: 600ms};
		.span-4 {transition-delay: 700ms};
		.span-5 {transition-delay: 800ms};
		.span-6 {transition-delay: 900ms};
		.span-7 {transition-delay: 1000ms};
		.span-8 {transition-delay: 1100ms};
		.span-9 {transition-delay: 1200ms};
		.span-10 {transition-delay: 1300ms};
		.span-11 {transition-delay: 1400ms};
		.span-12 {transition-delay: 1500ms};
		.span-13 {transition-delay: 1600ms};
		.span-14 {transition-delay: 1700ms};
		.span-15 {transition-delay: 1800ms};
		.span-16 {transition-delay: 1900ms};
		.span-17 {transition-delay: 2000ms};
		.span-18 {transition-delay: 2100ms};
		.span-19 {transition-delay: 2200ms};
		.span-20 {transition-delay: 2300ms};

		&.inactive {

			.span-item {
				opacity: 0;
				transform: translateY(50px);							
			}			
		}

		&.active {

			.span-item {
				opacity: 1;
				transform: translateY(0px);
			}
		}
	}

	.lead {
		color: ${colors.white};
		font-family: ${fonts.AeonikMono};
		font-size: 30px;
		font-weight: 400;
		line-height: 110%;
	}

	.separator {
		height: 1px;
		width: 100%;
		margin-top: 23px;
		margin-bottom: 12px;
		background-color: ${colors.white};
	}

	.p-small {
		color: ${colors.white};
		font-size: 19px;
		font-weight: 400;
		line-height: 130%;
	}

	.keyfacts-text {
		font-family: ${fonts.AeonikPro};
		align-items: center;
		display: flex;
		font-size:19px;
		min-height: 42px;

		@media ${devices.desktop} {
			padding-right: 150px;
		}

		@media ${devices.mobile} {
			padding-right: 16px;
		}
	}

	@media ${devices.tabletToDesktop} {
		min-width: 300px;
		padding: 36px;
	}

	@media ${devices.mobile} {
		padding: 32px;
		flex-basis: 100%;
		max-width: 100%;
	}
`;
